module.exports = __webpack_public_path__ + "img/yoojo-logo.1b58a04f.png";